import { ShowModal } from '@citrite/web-ui-component';
                            
import { showSaasLaunchInCEPDialog as showSaasLaunchInCEPDialogForWSUI } from 'Environment/launchResource/SaasLaunchInCEPDialog';
          
import {
	X_CITRIX_LAUNCH_TYPE,
	X_CITRIX_LAUNCH_TYPE_CHROME_VALUE,
} from 'javascript/interceptors/Headers';
                           
                                                                                                                
          
import {
	CITRIX_CEP_CWA_PROTOCOL,
	SchemeCaller,
} from 'Workspace/SchemeCallHandler/schemeCallHandler';

const showSaasLaunchInCEPDialog = IS_UI_LIBRARY_BUILD
	? showSaasLaunchInCEPDialogForPurpleUI
	: showSaasLaunchInCEPDialogForWSUI;
export interface ICEPHandler {
	shouldLaunchInCEP: (headers: { [key: string]: string }) => boolean;
	launchSaasAppInCEPViaCWA: (url: string, showModal: ShowModal) => void;
	canLaunchResourceInCEP: (resourceContentUrl: string) => boolean;
}

export function canLaunchResourceInCEP(resourceContentUrl: string) {
	return (
		!!resourceContentUrl &&
		resourceContentUrl
			.toLowerCase()
			.startsWith(CITRIX_CEP_CWA_PROTOCOL.toLowerCase() + '://')
	);
}

export function shouldLaunchInCEP(headers: { [key: string]: string }) {
	const launchTypeKey = Object.keys(headers).find(
		key => key.toLowerCase() === X_CITRIX_LAUNCH_TYPE.toLowerCase()
	);
	const launchType = headers[launchTypeKey];
	return launchType?.toLowerCase() === X_CITRIX_LAUNCH_TYPE_CHROME_VALUE.toLowerCase();
}

export function launchSaasAppInCEPViaCWA(url: string) {
	const invokeScheme = () => SchemeCaller.getInstance().makeSchemeCallV2(url);
	invokeScheme();
	showSaasLaunchInCEPDialog(invokeScheme);
}

export const cepHandler: ICEPHandler = {
	shouldLaunchInCEP,
	launchSaasAppInCEPViaCWA,
	canLaunchResourceInCEP,
};

export const defaultCEPHandler: ICEPHandler = {
	shouldLaunchInCEP: () => false,
	launchSaasAppInCEPViaCWA: () => {},
	canLaunchResourceInCEP: () => false,
};
